module.exports = __webpack_public_path__ + "img/felc-标准赛区.5d2e1159.png";